export default function ChevronLeftIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="chevron-left"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 22}
      height={height ? height : width ? width : 22}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="m26.6 35.25-9.9-9.9q-.3-.3-.45-.65-.15-.35-.15-.75t.15-.75q.15-.35.45-.65l9.95-9.95q.6-.6 1.425-.6.825 0 1.425.6.6.6.575 1.45-.025.85-.625 1.45L21 23.95l8.5 8.5q.6.6.6 1.4 0 .8-.6 1.4-.6.6-1.45.6t-1.45-.6Z"
      />
    </svg>
  );
}
